import type { Address } from '@expert/types';

export interface AppUserProfile {
    gender: string;
    firstName: string;
    lastName: string;
    email: string;
    birthDate: number;
    shippingAddress: Address;
    invoiceAddress: Address;
    shoppingCartId?: string;
    reservationCartId?: string;
}

export interface NeoUserProfile {
    '@class': string;
    client: string;
    locale: string;
    addresses: Array<Address>;
    institutionMappings: Array<{ institution: string; roles: Array<string> }>;
    userId: string;
    roles: Array<string>;
    id: string;
    defaultAddress: string;
    shopCustomer: {
        defaultShippingAddress: string;
        shoppingCart: string;
        reservationCart: string;
        wishlist: object;
    };
    sessionIdentifier: string;
    additionalInfo: Record<string, any>;
    registered: boolean;
    revision: number;
    userStatus: string;
}

export interface NeoSystemUser {
    id: string;
    firstName: string;
    lastName: string;
    gender: string;
    birthday: number;
    email: string;
    emailLowerCase: string;
    userStatus: string;
    roles: Array<string>;
}

export enum Gender {
    FEMALE,
    MALE,
    DIVERSE,
    COMPANY,
    FAMILY,
    UNKNOWN
}

// This is only a part of the object because I was too lazy -_-
export interface KeycloakAccountData {
    username: string;
    firstName: string;
    lastName: string;
    email: string;
    attributes: {
        birthdate?: Array<string>;
        country?: Array<string>;
        gender?: Array<string>;
        house_number?: Array<string>;
        locality?: Array<string>;
        paybackIntegration?: Array<string>;
        phoneNumber?: Array<string>;
        postal_code?: Array<string>;
        street?: Array<string>;
        street_address?: Array<string>;
        address_addition?: Array<string>;
        [attribute: string]: Array<string> | undefined;
    };
}